module.exports = __webpack_public_path__ + "static/media/yuan5.b35f4c21.png";